import { Brick, registerBrick, Transaction, CloudObject, Auth, User } from 'olympe';
import { getLogger } from "@olympeio/core";
import { canDelete } from '../../common/section_bcp/BcpWorkflowAuthorizations';
import { getApplicationContext } from '../utils/Context';

export default class DeleteMultipleBCPRequests extends Brick {
    callExecuteQuery = async (t1, logger) => {
        try {
            let dbExecuteResult = await t1.execute();
            logger.info("::::: Execute Result ::::", dbExecuteResult);
        } catch (error) {
            throw new Error(`Error in accepting workflow for BCP:${error}`);
        }
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {number} controlFlow
     * @param {*} selectedBCPs
     * @param {string} adminIndicator
     * @param {function()} forwardEvent
     * @param {function(boolean)} setDeletionStatus
     */
    async update($, [selectedBCPs, adminIndicator], [forwardEvent, setDeletionStatus]) {
        // Write your code here.
        const logger = getLogger('DeleteMultipleBCPRequests');
        let applicationContext = getApplicationContext($);
        let deletionStatusArray = [];
        for (const [key, bcpRequest] of Object.entries(selectedBCPs)) {
            const email = CloudObject.get(Auth.getCurrentUser()).get(User.loginProp);
            try {
                const t1 = new Transaction(true);
                const isAdmin = applicationContext.get('isadmin');
                const canDeleteBCP = canDelete(isAdmin, email, bcpRequest)
                if (canDeleteBCP) {
                    t1.delete(bcpRequest)
                    let isBCPDeleted = await this.callExecuteQuery(t1, logger)
                    logger.info("isBCPDeleted", isBCPDeleted)
                    deletionStatusArray.push(bcpRequest)
                }
                // For BP, PM, and other QA stakeholder we need to call following method to delete
            } catch (error) {
                setDeletionStatus(false)
                logger.error("Error happened while deleting multiple BCP Request", error);
                // Handle errors during the send email process
                throw new Error(`Error in accepting workflow for BCP:${error}`);
            }
        }
        logger.info("After deletion multiple request the array", deletionStatusArray)
        applicationContext.set('selectedBCPs', [])
        setDeletionStatus(true)
        forwardEvent();
    }
}

registerBrick('01981372e66a3e46cd91', DeleteMultipleBCPRequests);
